// extracted by mini-css-extract-plugin
export default {"container":"pj-z","blurb":"qj-z","links":"rj-z"};